import { SMLUpgradeFeature } from '../music24/config/music24PlanCapabilities';
import { NextPlanForFeature, useNextPlanForFeature } from '../music24/hooks/useNextPlanForFeature';

/**
 * The owner's plan, and the cheapest plan with more seats (`null` when no plan has more). The
 * same capabilities `LockedControl` reads, so its chip and the seat note name the same plan.
 */
export function useSeatUpgradePlan(): NextPlanForFeature {
  return useNextPlanForFeature(SMLUpgradeFeature.seats);
}
